/**
 * PostDetailRelated 컴포넌트
 * @description 글 바닥의 "More stories" — 최신 글 세 장. 매거진은 한 편이 끝나면 다음 편을
 *   권한다. 서버가 실패하거나 하나도 없으면 줄 자체를 세우지 않는다.
 *
 *   지금 글과 같은 언어로 받는다. 그 언어의 번역이 없는 글은 원문으로 실려 오고, 카드는 글마다
 *   실제로 나간 언어의 주소로 잇는다.
 */
import { postDetailStyles } from "./PostDetail.styles";
import type { PostDetailRelatedProps } from "./PostDetail.types";
import PostDetailRelatedCard from "./PostDetailRelatedCard";

import { blogCopyOf } from "../../constants/blogCopy";
import type { BlogItem } from "../../dtos";
import { getRelatedPosts } from "../../repositories/postApiRepository";
import { toBlogLanguage, type BlogLanguage } from "@/shared/config";
import { Reveal, REVEAL_STAGGER } from "@/shared/ui";

async function loadRelated(
  slug: string,
  language: BlogLanguage,
): Promise<BlogItem[]> {
  try {
    return await getRelatedPosts(slug, language);
  } catch (error) {
    console.error("[PostDetailRelated] failed to load related posts", error);
    return [];
  }
}

export default async function PostDetailRelated({
  post,
}: PostDetailRelatedProps) {
  const language = toBlogLanguage(post.language);
  const posts = await loadRelated(post.slug, language);
  if (posts.length === 0) return null;

  return (
    <section lang={language} className={postDetailStyles.related.root}>
      <Reveal>
        <h2 className={postDetailStyles.related.title}>
          {blogCopyOf(post).related}
        </h2>
      </Reveal>
      <div className={postDetailStyles.related.grid}>
        {posts.map((related, index) => (
          <Reveal key={related.slug} delay={index * REVEAL_STAGGER}>
            <PostDetailRelatedCard from={post} post={related} index={index} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}
